<template>
  <header class="header" :class="{ 'header-transparent': isTransparent }">
    <div class="container">
      <div class="header__inner">
        <div class="header__main">
          <router-link class="logo" to="/">
            <img src="@/assets/images/logo.svg" alt="WeThink" />
          </router-link>
        </div>

        <div class="header__action">
          <nav class="menu">
            <div class="menu-main">
              <ul class="menu-main__list">
                <li>
                  <a href="http://info.wethink.eu/" target="_blank" rel="noopener">News</a>
                </li>
                <li>
                  <a href="http://info.wethink.eu/" target="_blank" rel="noopener">Events</a>
                </li>
                <li>
                  <a href="http://info.wethink.eu/" target="_blank" rel="noopener">Partners</a>
                </li>
              </ul>
            </div>

            <button
              class="menu__btn"
              type="button"
              :class="{ 'menu__btn--active': active }"
              aria-label="Toggle menu"
              @click="toggleMenu"
            >
              <span class="menu__btn-line"></span>
            </button>

            <div class="menu-mobile" :class="{ 'menu-mobile--active': active }">
              <ul class="menu-mobile__list">
                <li v-if="authUser" @click="closeMenu">
                  <router-link class="menu-link-badge" :to="{ name: 'MessagesPage' }">
                    <span
                      v-if="unreadMessageCount"
                      class="message_badge"
                      :class="classBadgeMessagesLength"
                    >
                      {{ unreadMessageCount }}
                    </span>
                    Messages
                  </router-link>
                </li>

                <li v-if="authUser" @click="closeMenu">
                  <!-- если у тебя My Projects — другой роут, просто поменяй name -->
                  <router-link :to="{ name: 'strategyProjectsPage' }">My Projects</router-link>
                </li>

                <li v-if="authUser" @click="closeMenu">
                  <router-link class="menu-link-badge" :to="{ name: 'profileSetting' }">
                    <span
                      v-if="unreadProfileCount"
                      class="message_badge"
                      :class="classBadgeProfileLength"
                    >
                      {{ unreadProfileCount }}
                    </span>
                    Profile
                  </router-link>
                </li>

                <li v-if="authUser" @click="logout">
                  <a>Logout</a>
                </li>

                <li v-if="!authUser" @click="closeMenu">
                  <router-link :to="{ name: 'login' }">Login</router-link>
                </li>
                <li v-if="!authUser" @click="closeMenu">
                  <router-link :to="{ name: 'register' }">Register</router-link>
                </li>
              </ul>

              <ul class="menu-mobile-main__list">
                <li @click="closeMenu">
                  <router-link :to="{ name: 'strategyProjectsPage' }">
                    Strategy Projects
                  </router-link>
                </li>
                <li @click="closeMenu">
                  <router-link :to="{ name: 'PrivateGroupsPage' }">Private Groups</router-link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import autorization from '@/mixins/autorization';
import me from '@/mixins/me';
import websocket from '@/mixins/websocket';
import badge from '@/mixins/badge';
import AutorizationService from '@/services/AutorizationService';

export default {
  name: 'AppHeader',
  mixins: [autorization, me, websocket, badge],
  props: {
    header: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      active: false,
      unreadMessageCount: 0,
      unreadProfileCount: 0,
      classBadgeMessagesLength: '',
      classBadgeProfileLength: '',
    };
  },
  computed: {
    authUser() {
      return this.$store.getters.getAuthUser;
    },
    isTransparent() {
      return Boolean(this.header && this.header.transperent);
    },
  },
  created() {
    if (!this.authUser) return;
    this.subscribeToChannel('personal', this.setMessagesCountFromWebsocket);
  },
  methods: {
    toggleMenu() {
      this.active = !this.active;
    },
    closeMenu() {
      this.active = false;
    },
    async logout() {
      try {
        await AutorizationService.logout();
        this.removeAutorization();
        this.closeMenu();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    setMessagesCountFromWebsocket(event) {
      const data = JSON.parse(event.data).message;
      this.unreadMessageCount = data.messages;
      this.unreadProfileCount = data.profile;
      this.$store.commit('SET_UNREAD_MESSAGES', data.messages);
    },
  },
  watch: {
    unreadMessageCount() {
      this.classBadgeMessagesLength = this.getClassBadgeLength(this.unreadMessageCount);
    },
    unreadProfileCount() {
      this.classBadgeProfileLength = this.getClassBadgeLength(this.unreadProfileCount);
    },
    $route() {
      this.closeMenu();
    },
  },
};
</script>

<style lang="scss" scoped>
/* важно только для позиционирования бейджей */
.menu-link-badge {
  position: relative;
}

.message_badge {
  &.two {
    width: 30px;
    border-radius: 40%;
  }

  &.three {
    width: 40px;
    border-radius: 40%;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  width: 20px;
  height: 20px;

  position: absolute;
  top: -10px;
  right: -10px;

  background-color: red;
  border-radius: 50%;

  z-index: 1;

  color: #fff;
  font-size: 12px;
  font-weight: 600;

  @media (max-width: 992px) {
    right: -20px;
  }
}
</style>
